import { useEffect, useRef } from "react";

export const useResizeObserver = <T extends HTMLElement>(
  ref: React.RefObject<T>,
  onResize: (size: { width: number; height: number }) => void
) => {
  const observerRef = useRef<ResizeObserver | null>(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    // Initial size
    const rect = node.getBoundingClientRect();
    onResize({ width: rect.width, height: rect.height });

    // Observe changes
    let timeout: NodeJS.Timeout | null = null;
    observerRef.current = new ResizeObserver(() => {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (!ref.current) return;
        const rect = ref.current.getBoundingClientRect();
        onResize({ width: rect.width, height: rect.height });
      }, 200); // debounce by 100ms
    });

    observerRef.current.observe(node);

    return () => {
      observerRef.current?.disconnect();
      observerRef.current = null;
    };
  }, [ref, onResize]);
};
